// Shared pure helpers for the coach dashboard tabs.
//
// ONLY behavior-identical logic that was copy-pasted across tabs lives here, so there
// is one definition to test and maintain. Helpers that LOOK similar but differ per tab
// (e.g. ClientsTab's fmtDate has an extra NaN guard and a different null rule than the
// others; its isExpiringSoon uses a raw-seconds window while a naive day-count version
// rounds differently) are deliberately NOT consolidated — merging them would silently
// change behavior. Those stay local to their tab and are tested there.

import { t } from "./coachTokens";

// ── Goal classification — identical in WeightTab & NutritionTab ──────────────────
export const GOAL_CUT = new Set(["AGGRESSIVE_CUT", "CUT", "MODERATE_CUT", "SHORT_CUT"]);
export const GOAL_GAIN = new Set(["MODERATE_BULK", "BULK", "AGGRESSIVE_BULK"]);

export const isGoalCut = (goal) => GOAL_CUT.has(goal);
export const isGoalGain = (goal) => GOAL_GAIN.has(goal);

// Goal-aware trend color: a cut goal is green when the trend is down, a gain goal is
// green when the trend is up; neutral otherwise (null/zero trend, or non-directional
// goal). Identical between WeightTab.trendColor and NutritionTab.trendColorFor.
export const goalAwareTrendColor = (goal, trend) => {
  if (trend == null || trend === 0) return t.t3;
  if (isGoalCut(goal)) return trend < 0 ? t.green : t.red;
  if (isGoalGain(goal)) return trend > 0 ? t.green : t.red;
  return t.t3;
};
